<div class="margin-1rem" fxLayout="row" *ngIf='field && field.booleanSelect'>
    <div [formGroup]="group" *ngFor="let select of field.booleanSelect.options">
        <button class="bold" mat-fab [ngClass]="{'selectionColor': changeSelectionColor(select.value), 'light-container': select.value == group.controls[this.field.name].value, 'opacity': select.value != group.controls[this.field.name].value}" (click)="setValue(select.value)">{{select.alias}}</button>
    </div>
</div>
<div class="margin-1rem">
    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error  *ngIf="group.get(field.name).value == false && group.get(field.name).errors?.required ">{{validation.message}}</mat-error>
    </ng-container>
</div>
